<template>
  <div class="card mb-25 border-0 radius-7 bg-white welcome-support-desk-box">
    <div
      class="card-body ps-15 pe-15 ps-sm-20 pe-sm-20 ps-md-25 pe-md-25 ps-lg-30 pe-lg-30 ps-xl-40 pe-xl-40 letter-spacing"
    >
      <div class="row align-items-center mt-20 mb-20">
        <div class="col-xxl-6">
          <div class="content">
            <h2 class="fw-semibold mb-8 text-white"><span class="fw-bold text-black">{{ getConfigurations.name }}</span></h2>
            <p class="fs-md-15 fs-lg-16">
              Abaixo estão as métricas totais de todo o periodo utilizado
            </p>


            <div class="row list justify-content-center width-card-totals col-12 flex-column flex-sm-column flex-row flex-xl-row flex-xxl-row flex-xxxl-row">
              <div class="col-lg-3 col-6 col-sm-3">
                <div class="p-15 mt-15 bg-18dcff radius-7">
                  <span class="d-block mb-6 fw-medium text-black-emphasis fs-13 text-uppercase">Uploads com sucesso</span>
                  <h4 class="mb-0 fw-black text-success">{{ getMetricsTotals.total_success }}</h4>
                </div>
              </div>

              <div class="col-lg-3 col-6 col-sm-3">
                <div class="p-15 mt-15 bg-f2f1f9 radius-7">
                  <span class="d-block mb-6 fw-medium text-black-emphasis fs-13 text-uppercase">Uploads com erro</span>
                  <h4 class="mb-0 fw-black text-danger">{{ getMetricsTotals.total_error }}</h4>
                </div>
              </div>

              <div class="col-lg-3 col-6 col-sm-3">
                <div class="p-15 mt-15 bg-ecf3f2 radius-7">
                  <span class="d-block mb-6 fw-medium text-black-emphasis fs-13 text-uppercase">Tempo total de gravação</span>
                  <h4 class="mb-0 fw-black text-primary">{{ convertTime(getMetricsTotals.total_time) }}</h4>
                </div>
              </div>

              <div class="col-lg-3 col-6 col-sm-3">
                <div class="p-15 mt-15 bg-faf7f7 radius-7">
                  <span class="d-block mb-6 fw-medium text-black-emphasis fs-13 text-uppercase">Tamanho total de gravação</span>
                  <h4 class="mb-0 fw-black text-info">{{ (getMetricsTotals.total_size / (1024 * 1024)).toFixed(2) + " MB" }}</h4>
                </div>
              </div>
            </div>



          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from "vue";
import { mapGetters } from 'vuex';
import moment from 'moment';

export default defineComponent({
  name: "MetricDashboardTotals",
  data() {
    return {
      updates: [
        {
          id: 1,
          bgClass: "bg-f2f1f9",
          title: "COURSES",
          class: "text-primary",
          number: "23",
        },
        {
          id: 2,
          bgClass: "bg-faf7f7",
          title: "CERTIFICATES",
          class: "text-danger",
          number: "9",
        },
        {
          id: 3,
          bgClass: "bg-ecf3f2",
          title: "SCORE",
          class: "text-success",
          number: "4.8",
        },
        {
          id: 4,
          bgClass: "bg-f3f7f9",
          title: "HRS LEARNED",
          class: "text-info",
          number: "822",
        },
      ],
    };
  },
  setup() {
    const formattedDate = ref("");

    onMounted(() => {
      const currentDate = new Date();
      formattedDate.value = `${currentDate.getDate()}/${
        (currentDate.getMonth() + 1).toString().padStart(2, '0')
      }/${currentDate.getFullYear()}`;
    });

    return {
      formattedDate,
    };
  },
  computed:{
    ...mapGetters([
      'getMetricsTotals',
      'getConfigurations'
    ])
  },
  methods: {
    convertTime(time: number | string) {
      const totalSeconds = Math.max(0, Math.floor(Number(time) || 0)); // lida com "96000.01243"
      const d = moment.duration(totalSeconds, 'seconds');

      const hours = Math.floor(d.asHours()); // horas **totais**, não %24
      const minutes = d.minutes();
      const seconds = d.seconds();

      const pad = (n: number) => String(n).padStart(2, '0');
      return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`; // ex.: 26:40:00
    }
  },
});
</script>
<style>
.width-card-totals{
  width: 650px !important;
}
</style>